
import React from "react"
import NumerableIconButton from "../../NumerableIconButton"
import { JARGON } from "../../../modules/constants"
import MapOutlinedIcon from "@mui/icons-material/MapOutlined"

function MapMenu(props) {
  // console.log('MapMenu props:', props)

  const { externalLinks, hubData, portrait } = props

  const tipEnabled = JARGON.EXTERNAL_LINK_TO + "Registered Address on Google Maps"
  const mapButton = {
    disabled: !externalLinks,
    tipEnabled,
    tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
    icon: <MapOutlinedIcon />,
    label: "Map of address",
    handleClick: () => { window.open(hubData.mapLink, "_blank") },
    fontWeight: "normal",
  }

  return (
    <div>
      <NumerableIconButton item={mapButton} portrait={portrait} />
    </div>
  )
}

export default MapMenu

